<template lang="pug">
.events
  sys-bar(:backable="true" ref="sysBar")
  .content(ref="content")
    router-view
  
</template>
<script>
import SysBar from '@/components/SysBar'
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'Events',
  components: { SysBar },
  props: {},
  data() {
    return {}
  },
  watch: {
    $route(val) {
      console.log(val)
      if (val.path === '/events/list') {
        this.setRouterBack('/')
        this.fetchEventList()
      }
    },
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    ...mapActions('app', ['GetMpEventList']),
    fetchEventList() {
      this.setPending(true)
      this.GetMpEventList()
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
  },
  created() {
    this.fetchEventList()
  },
  mounted() {
    this.$refs.content.style.height =
      window.innerHeight -
      this.$refs.sysBar.$el.getBoundingClientRect().height +
      'px'
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.events
  background: #ffffff
  .content
    position: relative
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(100%)
</style>
